import { setSafe } from "../../../util/storeHelper";
import * as actions from "../actions/loadOrder";
export const modLoadOrderReducer = {
    reducers: {
        [actions.setLoadOrderEntry]: (state, payload) => {
            const { profileId, modId, loEntry } = payload;
            return setSafe(state, [profileId, modId], loEntry);
        },
    },
    defaults: {},
};
